"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var drive_types_1 = require("../../../common/types/drive.types");
var json_1 = require("../../../common/helpers/json");
var AdminCompleteDriveController = /** @class */ (function () {
    function AdminCompleteDriveController($rootScope, $scope, $state, UserService, UsersModel, VehiclesModel, DrivesModel, SchoolsModel, FlashService, driveSession, PoliciesModel, $q) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.UserService = UserService;
        this.UsersModel = UsersModel;
        this.VehiclesModel = VehiclesModel;
        this.DrivesModel = DrivesModel;
        this.FlashService = FlashService;
        this.driveSession = driveSession;
        Object.assign(this.driveSession, (0, drive_types_1.formatDriveForDisplay)(this.driveSession));
        this.endTimeMoment = (0, time_1.addMinutes)((0, time_1.timeStringToDate)(this.driveSession.start_time), this.driveSession.session_length);
        this.driveDate = new Date(this.driveSession.drive_date + " " + this.driveSession.start_time);
        this.policies = {};
        this.currentUser = UserService.getCurrentUser();
        this.loading = true;
        // load all of the things!
        var getSchool = SchoolsModel.getSchoolByID(this.currentUser.school_id);
        var getPolicies = PoliciesModel.getAll();
        var getDriveMeta = DrivesModel.getDriveMeta(this.driveSession.id);
        $q.all([getSchool, getPolicies, getDriveMeta]).then(function (responses) {
            _this.formatSchoolResponse(responses[0]);
            _this.formatPoliciesResponse(responses[1]);
            _this.driveSession = _this.formatDriveSession(responses[2]);
            _this.loading = false;
        });
    }
    AdminCompleteDriveController.prototype.formatDriveSession = function (response) {
        var student = response.drive.student;
        var hasGuardian = student.usermeta.filter(function (meta) {
            return meta.meta_key === "guardian";
        }).length > 0;
        var parentMeta;
        if (hasGuardian) {
            parentMeta = student.usermeta.find(function (meta) { return meta.meta_key === "guardian"; }).meta_value;
            student.guardian = JSON.parse(parentMeta);
        }
        student.phone = student.usermeta.filter(function (meta) {
            return meta.meta_key === "phone";
        })[0].meta_value;
        var dob_meta = student.usermeta.find(function (meta) { return meta.meta_key === "dob"; });
        if (dob_meta) {
            student.dob = dob_meta.meta_value;
        }
        else {
            student.dob = "";
        }
        var drive = Object.assign(this.driveSession, response.drive);
        return drive;
    };
    AdminCompleteDriveController.prototype.formatPoliciesResponse = function (response) {
        var _this = this;
        response.policies.forEach(function (policy) {
            var policyName = policy.name;
            _this.policies[policyName] = { id: policy.id };
            var policyMeta = {};
            policy.policymeta.forEach(function (meta) {
                policyMeta[meta.meta_key] = (0, json_1.isJson)(meta.meta_value)
                    ? JSON.parse(meta.meta_value)
                    : meta.meta_value;
            });
            _this.policies[policyName].policymeta = policyMeta;
        });
    };
    AdminCompleteDriveController.prototype.formatSchoolResponse = function (response) {
        // Safely filter locations - only include those with zoneparts when zoneparts exist
        var locationsWithZones = response.locations.filter(function (location) {
            return location.zoneparts && location.zoneparts.length > 0;
        });
        response.locations = locationsWithZones;
        this.school = response;
    };
    AdminCompleteDriveController.prototype.submit = function () {
        var _this = this;
        this.submitted = true;
        this.DrivesModel.complete(this.driveSession)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.submitted = false;
            _this.$state.go("drivecoach.admin.dashboard", {}, { reload: true });
        })
            .catch(function (Error) {
            _this.submitted = false;
        });
    };
    return AdminCompleteDriveController;
}());
AdminCompleteDriveController.$inject = [
    "$rootScope",
    "$scope",
    "$state",
    "UserService",
    "UsersModel",
    "VehiclesModel",
    "DrivesModel",
    "SchoolsModel",
    "FlashService",
    "driveSession",
    "PoliciesModel",
    "$q",
];
exports.default = AdminCompleteDriveController;
